import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var _dec, _class;

import { TYPES } from '@antv/l7-core';
import Source from '@antv/l7-source';
import { injectable } from 'inversify';
import 'reflect-metadata';
var DataSourcePlugin = (_dec = injectable(), _dec(_class = /*#__PURE__*/function () {
  function DataSourcePlugin() {
    _classCallCheck(this, DataSourcePlugin);
  }

  _createClass(DataSourcePlugin, [{
    key: "apply",
    value: function apply(layer) {
      var _this = this;

      this.mapService = layer.getContainer().get(TYPES.IMapService);
      layer.hooks.init.tap('DataSourcePlugin', function () {
        var source = layer.getSource();

        if (!source) {
          // Tip: 用户没有传入 source 的时候使用图层的默认数据
          var _ref = layer.sourceOption || layer.defaultSourceConfig,
              data = _ref.data,
              options = _ref.options;

          source = new Source(data, options);
          layer.setSource(source);
        }

        if (source.inited) {
          _this.updateClusterData(layer);
        } else {
          source.once('update', function () {
            _this.updateClusterData(layer);
          });
        }
      }); // 检测数据是否需要更新

      layer.hooks.beforeRenderData.tap('DataSourcePlugin', function () {
        var neeUpdateCluster = _this.updateClusterData(layer);

        var dataSourceNeedUpdate = layer.dataState.dataSourceNeedUpdate;
        layer.dataState.dataSourceNeedUpdate = false;
        return neeUpdateCluster || dataSourceNeedUpdate;
      });
    }
  }, {
    key: "updateClusterData",
    value: function updateClusterData(layer) {
      // Tip: 矢量瓦片不需要进行聚合操作
      if (layer.isTileLayer || layer.tileLayer) return false;
      var source = layer.getSource();
      var cluster = source.cluster;
      var _source$clusterOption = source.clusterOptions.zoom,
          zoom = _source$clusterOption === void 0 ? 0 : _source$clusterOption;
      var newZoom = this.mapService.getZoom() - 1;
      var dataSourceNeedUpdate = layer.dataState.dataSourceNeedUpdate;

      if (cluster && dataSourceNeedUpdate) {
        // 数据发生更新
        source.updateClusterData(Math.floor(newZoom));
      } // 如果 dataSource 有更新，跳过 zoom 的判断，直接更新一次


      if (cluster && Math.abs(layer.clusterZoom - newZoom) >= 1) {
        if (zoom !== Math.floor(newZoom)) {
          source.updateClusterData(Math.floor(newZoom));
        }

        layer.clusterZoom = newZoom;
        return true;
      }

      return false;
    }
  }]);

  return DataSourcePlugin;
}()) || _class);
export { DataSourcePlugin as default };